var _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _ellipse, _ellipse2, _path7, _path8, _path9, _path10, _path11, _line, _line2, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShuruDesertSad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 464.65 372.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m35.12,200.9C22.12,73.5,123.42,2,232.32,2s210.2,71.5,197.2,198.9",
    fill: "#d97f56",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m417.72,213.5c0,92.1-83,157.3-185.4,157.3S47.02,305.6,47.02,213.5,130.02,37.5,232.42,37.5s185.3,84,185.3,176h0Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m417.72,213.5c0,92.1-83,157.3-185.4,157.3S47.02,305.6,47.02,213.5,130.02,37.5,232.42,37.5s185.3,84,185.3,176h0Z",
    fill: "none",
    stroke: "#020500",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m35.12,200.9C22.12,73.5,123.42,2,232.32,2s210.2,71.5,197.2,198.9",
    fill: "none",
    stroke: "#020500",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m232.32,17.4c-126.3,2.6-170.2,97.8-176,116.2-6,19.1-17.7,73.8,78.1-5.6,0,0-30.9,89.2,70.8,9,0,0-1.2,28.2,27.1,28.2s27.1-28.2,27.1-28.2c101.7,80.2,70.8-9,70.8-9,95.8,79.5,84.1,24.7,78.1,5.6-5.8-18.4-49.7-113.6-176-116.2Z",
    fill: "#f6e6cf",
    strokeWidth: 0
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m232.32,17.4c-126.3,2.6-170.2,97.8-176,116.2-6,19.1-17.7,73.8,78.1-5.6,0,0-30.9,89.2,70.8,9,0,0-1.2,28.2,27.1,28.2s27.1-28.2,27.1-28.2c101.7,80.2,70.8-9,70.8-9,95.8,79.5,84.1,24.7,78.1,5.6-5.8-18.4-49.7-113.6-176-116.2Z",
    fill: "none",
    stroke: "#020500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 328.02,
    cy: 271.9,
    r: 27,
    fill: "#f6e6cf",
    strokeWidth: 0
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.62,
    cy: 271.9,
    r: 27,
    fill: "#f6e6cf",
    strokeWidth: 0
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 313.02,
    cy: 230.4,
    rx: 17.5,
    ry: 25,
    fill: "#020500",
    strokeWidth: 0
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 151.62,
    cy: 230.4,
    rx: 17.5,
    ry: 25,
    fill: "#020500",
    strokeWidth: 0
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m257.12,279.3c-9.3-17-39.9-16.6-49.6,0",
    fill: "none",
    stroke: "#020500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m18.32,300.9c14.8.5,29.5-.8,44-3.9,2.3-.5,3.9-2.9,3.7-5.6-3.9-43.5-7.8-87-11.7-130.4-.2-2.7-2.2-4.8-4.6-4.9-14.8-.5-29.5.8-44,3.9-2.3.5-3.9,2.9-3.7,5.6,3.9,43.5,7.8,87,11.6,130.4.3,2.7,2.3,4.8,4.7,4.9Z",
    fill: "#d97f56",
    strokeWidth: 0
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m18.32,300.9c14.8.5,29.5-.8,44-3.9,2.3-.5,3.9-2.9,3.7-5.6-3.9-43.5-7.8-87-11.7-130.4-.2-2.7-2.2-4.8-4.6-4.9-14.8-.5-29.5.8-44,3.9-2.3.5-3.9,2.9-3.7,5.6,3.9,43.5,7.8,87,11.6,130.4.3,2.7,2.3,4.8,4.7,4.9Z",
    fill: "none",
    stroke: "#020500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m446.42,300.9c-14.8.5-29.5-.8-44-3.9-2.3-.5-3.9-2.9-3.6-5.6,3.9-43.5,7.8-87,11.6-130.4.2-2.7,2.2-4.8,4.6-4.9,14.8-.5,29.5.8,44,3.9,2.3.5,3.9,2.9,3.6,5.6-3.9,43.5-7.8,87-11.6,130.4-.2,2.7-2.2,4.8-4.6,4.9Z",
    fill: "#d97f56",
    strokeWidth: 0
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m446.42,300.9c-14.8.5-29.5-.8-44-3.9-2.3-.5-3.9-2.9-3.6-5.6,3.9-43.5,7.8-87,11.6-130.4.2-2.7,2.2-4.8,4.6-4.9,14.8-.5,29.5.8,44,3.9,2.3.5,3.9,2.9,3.6,5.6-3.9,43.5-7.8,87-11.6,130.4-.2,2.7-2.2,4.8-4.6,4.9Z",
    fill: "none",
    stroke: "#020500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 301.02,
    y1: 200.5,
    x2: 339.32,
    y2: 214.9,
    fill: "none",
    stroke: "#020500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 163.72,
    y1: 200.5,
    x2: 125.42,
    y2: 214.9,
    fill: "none",
    stroke: "#020500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m128.02,266.1c-1.8,5.9,1.3,11.4,6.9,12.8,7.7,1.9,12.8-4.8,11-10.7-3.4-11.1,2.5-18.8.3-18.5-9.2,1-16.3,10.5-18.2,16.4h0Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m128.02,266.1c-1.8,5.9,1.3,11.4,6.9,12.8,7.7,1.9,12.8-4.8,11-10.7-3.4-11.1,2.5-18.8.3-18.5-9.2,1-16.3,10.5-18.2,16.4h0Z",
    fill: "none",
    stroke: "#020500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m135.12,313c0,6.2,4.6,10.1,10.3,10.1s10.3-3.9,10.3-10.1-8.1-20.1-10.3-20.1c-1.8,0-10.3,13.9-10.3,20.1Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m135.12,313c0,6.2,4.6,10.1,10.3,10.1s10.3-3.9,10.3-10.1-8.1-20.1-10.3-20.1c-1.8,0-10.3,13.9-10.3,20.1Z",
    fill: "none",
    stroke: "#020500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m336.62,266.1c1.9,5.9-1.3,11.4-6.9,12.8-7.7,1.9-12.8-4.8-11-10.7,3.5-11.1-2.5-18.8-.3-18.5,9.3,1,16.4,10.5,18.2,16.4h0Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m336.62,266.1c1.9,5.9-1.3,11.4-6.9,12.8-7.7,1.9-12.8-4.8-11-10.7,3.5-11.1-2.5-18.8-.3-18.5,9.3,1,16.4,10.5,18.2,16.4h0Z",
    fill: "none",
    stroke: "#020500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m329.52,313c0,6.2-4.6,10.1-10.3,10.1s-10.3-3.9-10.3-10.1,8.1-20.1,10.3-20.1c1.9,0,10.3,13.9,10.3,20.1Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m329.52,313c0,6.2-4.6,10.1-10.3,10.1s-10.3-3.9-10.3-10.1,8.1-20.1,10.3-20.1c1.9,0,10.3,13.9,10.3,20.1Z",
    fill: "none",
    stroke: "#020500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShuruDesertSad);
export default __webpack_public_path__ + "static/media/shuru_desert_sad.04b5bd9a7209e6ec988428f0832dff94.svg";
export { ForwardRef as ReactComponent };